'use strict'

export default class ExploreMap {
  constructor () {
    this.internal = {
      toggleRulesSpecies: null,
      toggleRulesFilters: null,
      searchIndex: null,
      activeFilters: [],
      activeSpecies: [],
      currentSearchResult: null,
      currentFilterLogic: null
    }
    const toggleRulesCsv = `
                   , temperature , precipitation , glacier , enneigement , secheresse , cycle-saisonnier , distribution-espece , abondance
mare-altitude      ,             ,       x       ,         ,      x      ,      x     ,        x         ,                     ,
herbivore          ,             ,               ,         ,      x      ,            ,                  ,          x          ,
chocard            ,      x      ,               ,         ,      x      ,            ,        x         ,                     ,     x
grenouille         ,      x      ,       x       ,         ,      x      ,      x     ,        x         ,                     ,
mesange            ,      x      ,               ,         ,      x      ,            ,        x         ,                     ,
arbre              ,      x      ,               ,         ,      x      ,            ,        x         ,                     ,
pelouse-lande      ,             ,               ,         ,      x      ,            ,        x         ,                     ,
lievre             ,      x      ,               ,         ,      x      ,            ,                  ,          x          ,
limite-foret       ,      x      ,       x       ,         ,             ,      x     ,                  ,          x          ,     x
zone-periglaciaire ,      x      ,               ,    x    ,      x      ,            ,        x         ,          x          ,
lagopede           ,      x      ,               ,    x    ,      x      ,            ,                  ,          x          ,
`

    // Read raw CSV into an array
    const toggleRulesCsvArray = []
    let lineIndex = 0
    for (const line of toggleRulesCsv.split('\n')) {
      if (line.trim().length > 0) {
        const cells = line.split(',')
        toggleRulesCsvArray[ lineIndex ] = []
        for (const cellIndex in cells) {
          toggleRulesCsvArray[ lineIndex ][ cellIndex ] = cells[ cellIndex ].trim()
        }
        lineIndex++
      }
    }

    // Convert into map
    const headers = toggleRulesCsvArray[ 0 ]
    this.internal.toggleRulesFilters = new Map()
    this.internal.toggleRulesSpecies = new Map()
    for (let lineIndex = 1; lineIndex < toggleRulesCsvArray.length; lineIndex++) {
      const rowName = toggleRulesCsvArray[ lineIndex ][ 0 ]
      this.internal.toggleRulesSpecies.set(rowName, [])
      for (let columnIndex = 1; columnIndex < toggleRulesCsvArray[ lineIndex ].length; columnIndex++) {
        if (toggleRulesCsvArray[ lineIndex ][ columnIndex ].length > 0) {
          // Filters map
          if (this.internal.toggleRulesFilters.has(headers[ columnIndex ])) {
            this.internal.toggleRulesFilters.get(headers[ columnIndex ]).push(rowName)
          } else {
            this.internal.toggleRulesFilters.set(headers[ columnIndex ], [ rowName ])
          }
          // Inverted species map
          this.internal.toggleRulesSpecies.get(rowName).push(headers[ columnIndex ])
        }
      }
    }
  }

  wire () {
    const that = this
    if ($('#explore-map').length > 0) {
      $('#explore-map .icon').on('click', event => that.onIconClicked(event))
    }
    return this
  }

  load () {
    if ($('#explore-map').length > 0) {
      this.loadSearchIndex()
    }
  }

  onIconClicked (event) {
    const clickedItem = $(event.currentTarget)
    const isActive = clickedItem.hasClass('active')

    // Clicked specie: activate corresponding filters
    if (clickedItem.parent().hasClass('species')) {
      if (this.currentFilterLogic && this.currentFilterLogic !== 'species') {
        this.internal.activeFilters = []
        this.internal.activeSpecies = []
      }
      this.currentFilterLogic = 'species'

      // Add filter (intersect)
      const clickedId = clickedItem.attr('data-id')
      this.internal.activeFilters = this.internal.toggleRulesSpecies.get(clickedId)
      this.internal.activeSpecies = [ clickedId ]
    } else {
      if (this.currentFilterLogic && this.currentFilterLogic === 'species') {
        this.internal.activeFilters = []
        this.internal.activeSpecies = []
      }
      this.currentFilterLogic = 'filters'

      // Clicked filter: activate corresponding icons
      const clickedId = clickedItem.attr('data-id')
      if (isActive) {
        // Remove filter
        this.internal.activeFilters = this.internal.activeFilters.filter(item => item !== clickedId)
        // Recompute displayed species, scanning all filters
        this.internal.activeSpecies = []
        if (this.internal.activeFilters.length > 0) {
          this.internal.activeSpecies = this.internal.toggleRulesFilters.get(this.internal.activeFilters[0])
          for (const filter of this.internal.activeFilters) {
            this.internal.activeSpecies = this.internal.activeSpecies.filter(item => this.internal.toggleRulesFilters.get(filter).indexOf(item) !== -1)
          }
        }
      } else {
        if (this.internal.activeFilters.length === 0) {
          // Set filter
          this.internal.activeFilters = [ clickedId ]
          this.internal.activeSpecies = this.internal.toggleRulesFilters.get(clickedId)
        } else {
          // Add filter (intersect)
          this.internal.activeFilters = this.internal.activeFilters.concat([ clickedId ])
          this.internal.activeSpecies = this.internal.activeSpecies.filter(item => this.internal.toggleRulesFilters.get(clickedId).indexOf(item) !== -1)
        }
      }
    }

    // Process search
    if (this.internal.activeSpecies.length > 0) {
      let searchTags = []
      for (const id of this.internal.activeSpecies) {
        searchTags = searchTags.concat($('.icon[data-id=' + id + ']').attr('data-terms').split(','))
      }
      this.internal.currentSearchResult = this.internal.searchIndex.filter(item => {
        return searchTags.some(function (keyword) {
          return item.keywords.includes(keyword)
        })
      })
    } else {
      // No specie chosen, display all
      this.internal.currentSearchResult = this.internal.searchIndex
    }

    // Redraw
    this.draw()
  }

  draw () {
    // Highlight icons
    $('.icon').removeClass('active')
    for (const id of this.internal.activeSpecies.concat(this.internal.activeFilters)) {
      $('.icon[data-id=' + id + ']').addClass('active')
    }

    // Add cards, according to found elements
    $('#cardsDrawArea').empty()
    $('#cardsDrawArea').loadTemplate($('#cardsResultTemplate'), this.internal.currentSearchResult)
  }

  loadSearchIndex () {
    const that = this
    const basePath = window.location.origin + window.location.pathname
    const jsonPath = basePath.endsWith('/') ? basePath + 'index.json' : basePath + '/index.json'
    fetch(jsonPath)
      .then(function (response) { return response.json() })
      .then(function (data) { that.internal.searchIndex = data.data })
      .catch(function (err) {
        console.error(err)
      })
  }
}
